const RECAPTCHA_SITE_KEY = '6LevtVEsAAAAAIQLgmeAY-N269TCf2bcj9PKXETR';
// const WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbyCdlePAt8m2i3Ay8UNNdsYPxUPL893LlX5Jo675_7OF5J7JMbNiKOI8RcCmpKWNodfyg/exec';
const WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbw0kGGn6C8lXgrrRh9HSrJM4_j1QuuvAwbZHqO6jah_pz8LEkIXLtNyb1tcAYHXZlI5_Q/exec';


const GPH_DAILY_LIMIT = 3;

const MAX_IMAGE_WIDTH = 1200;
const MAX_IMAGE_HEIGHT = 1200;
const IMAGE_QUALITY = 0.8;
const MAX_FILE_SIZE = 500 * 1024;

// ====================== DAILY LIMIT (CLIENT SIDE) ======================
function gphTodayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

function gphGetStore() {
  try {
    return JSON.parse(localStorage.getItem('gph_daily_limit') || '{}');
  } catch (e) {
    return {};
  }
}

function gphSaveStore(store) {
  try {
    localStorage.setItem('gph_daily_limit', JSON.stringify(store));
  } catch (e) {
    console.warn('Could not save daily limit to localStorage');
  }
}

function gphCanSubmit() {
  const store = gphGetStore();
  const today = gphTodayKey();
  return (store[today] || 0) < GPH_DAILY_LIMIT;
}

function gphRecordSubmit() {
  const store = gphGetStore();
  const today = gphTodayKey();
  store[today] = (store[today] || 0) + 1;
  gphSaveStore(store);
}

function gphGetRemainingSubmissions() {
  const store = gphGetStore();
  const today = gphTodayKey();
  return GPH_DAILY_LIMIT - (store[today] || 0);
}

// ====================== IMAGE COMPRESSION ======================
function compressImage(file, maxWidth, maxHeight, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > maxWidth) { height *= maxWidth / width; width = maxWidth; }
        } else {
          if (height > maxHeight) { width *= maxHeight / height; height = maxHeight; }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        const compressed = canvas.toDataURL('image/jpeg', quality);
        console.log('Original:', (file.size / 1024).toFixed(2), 'KB → Compressed:', (compressed.length * 0.75 / 1024).toFixed(2), 'KB');
        resolve(compressed);
      };
      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

// ====================== RECAPTCHA ======================
let recaptchaWidgetId = null;
let recaptchaVerified = false;

function onRecaptchaLoad() {
  recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
    sitekey: RECAPTCHA_SITE_KEY,
    callback: onCaptchaSuccess,
    'expired-callback': onCaptchaExpired,
    'error-callback': onCaptchaError,
    theme: 'light',
    size: 'normal'
  });
}

function onCaptchaSuccess(token) {
  recaptchaVerified = true;
  document.getElementById('submitBtn').disabled = false;
  document.getElementById('recaptcha-error').style.display = 'none';
}

function onCaptchaExpired() {
  recaptchaVerified = false;
  document.getElementById('submitBtn').disabled = true;
  grecaptcha.reset(recaptchaWidgetId);
}

function onCaptchaError() {
  recaptchaVerified = false;
  document.getElementById('submitBtn').disabled = true;
}

// ====================== LABEL FORMAT HINT ======================
document.getElementById('label')?.addEventListener('blur', function () {
  const label = this.value.trim();
  const indicator = document.getElementById('label-type-indicator');
  if (!label) { indicator.style.display = 'none'; return; }
  const match = label.replace(/[\s-]/g, '').match(/^(\d{7})-?(\d{1,3})$/);
  if (!match) {
    indicator.innerHTML = `<span style="color:#dc2626;">Invalid redemption code format</span>`;
    indicator.style.display = 'block';
  } else {
    indicator.innerHTML = '';
    indicator.style.display = 'none';
  }
});

// ====================== FORM SUBMIT ======================
document.getElementById('gphForm')?.addEventListener('submit', async function (e) {
  e.preventDefault();

  const form = e.target;
  const resultBox = document.getElementById('gph-result');
  const submitBtn = document.getElementById('submitBtn');

  function showResult(success, msg) {
    resultBox.style.display = 'block';
    resultBox.innerHTML = msg;
    resultBox.className = success ? 'gph-result success' : 'gph-result error';
    resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function resetBtn() {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Submit Redemption';
  }

  const email         = document.getElementById('email').value.trim();
  const mobile        = document.getElementById('mobile').value.trim();
  const label         = document.getElementById('label').value.trim();
  const file          = document.getElementById('photo').files[0];
  const shippingAddress = document.getElementById('shippingAddress').value.trim();
  const shippingCity    = document.getElementById('shippingCity').value.trim();
  const shippingState   = document.getElementById('shippingState').value.trim().toUpperCase();
  const shippingZip     = document.getElementById('shippingZip').value.trim();

  // ---- Validations ----
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showResult(false, 'Please enter a valid email address (e.g., example@domain.com)');
    return;
  }
  if (!gphCanSubmit()) {
    showResult(false, 'You have reached the maximum number of submissions for today.');
    return;
  }
  if (!file) {
    showResult(false, 'Please upload an image');
    return;
  }
  if (!['image/jpeg','image/jpg','image/png','image/gif','image/webp'].includes(file.type)) {
    showResult(false, 'Please upload a valid image file (JPG, PNG, GIF, WEBP)');
    return;
  }
  if (file.size > 10 * 1024 * 1024) {
    showResult(false, 'Image size must be less than 10MB');
    return;
  }
  if (!recaptchaVerified) {
    showResult(false, 'Please complete the security verification');
    return;
  }

  submitBtn.disabled = true;
  submitBtn.textContent = 'Processing image...';

  // ---- Image processing ----
  let imageBase64;
  try {
    if (file.size > MAX_FILE_SIZE) {
      submitBtn.textContent = 'Compressing image...';
      imageBase64 = await compressImage(file, MAX_IMAGE_WIDTH, MAX_IMAGE_HEIGHT, IMAGE_QUALITY);
    } else {
      submitBtn.textContent = 'Reading image...';
      imageBase64 = await readFileAsBase64(file);
    }
    if (!imageBase64 || imageBase64.length < 100) {
      showResult(false, 'Failed to process image. Please try again.');
      resetBtn();
      return;
    }
  } catch (imgErr) {
    console.error('Image processing error:', imgErr);
    showResult(false, 'Failed to process image. Please try a different image.');
    resetBtn();
    return;
  }

  submitBtn.textContent = 'Submitting...';

  // ---- Re-check reCAPTCHA token after compression (may have expired during long compression) ----
  const recaptchaToken = grecaptcha.getResponse(recaptchaWidgetId);
  if (!recaptchaToken || recaptchaToken.trim() === '') {
    showResult(false, 'Security verification expired. Please complete the reCAPTCHA again and resubmit.');
    grecaptcha.reset(recaptchaWidgetId);
    recaptchaVerified = false;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submit Redemption';
    return;
  }

  // =========================================================
  // CRITICAL FIX — WHY "NETWORK ERROR" HAPPENS:
  //
  // Google Apps Script Web Apps do NOT respond to CORS preflight
  // (OPTIONS) requests correctly. Any Content-Type that is NOT
  // one of: text/plain, application/x-www-form-urlencoded, or
  // multipart/form-data triggers a preflight. Even FormData can
  // trigger it in some browser/server combinations.
  //
  // Additionally, GAS redirects POST requests internally before
  // responding. Without redirect:'follow', the browser sees the
  // redirect, cancels the cross-origin request, and throws
  // "Network error" even though the server was reached.
  //
  // THE FIX:
  // 1. Send body as Content-Type: text/plain → no preflight at all
  // 2. Set redirect: 'follow' → browser follows the GAS redirect
  // 3. On the server, read via e.postData.contents + JSON.parse()
  // =========================================================
  const payload = JSON.stringify({
    first_name:       document.getElementById('firstName').value,
    last_name:        document.getElementById('lastName').value,
    email:            email,
    mobile:           mobile,
    shipping_address: shippingAddress,
    shipping_city:    shippingCity,
    shipping_state:   shippingState,
    shipping_zip:     shippingZip,
    label:            label,
    status:           'SUBMITTED',
    image:            imageBase64,
    recaptcha:        recaptchaToken
  });

  console.log('Sending request to server...');

  // 90-second timeout — GAS can be slow (image upload + sheet + emails)
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 90000);

  try {
    const res = await fetch(WEB_APP_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' }, // avoids CORS preflight
      body: payload,
      redirect: 'follow',                          // required for GAS redirects
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    // Read as text first — GAS can return an HTML error page on quota/deploy errors.
    // Calling res.json() directly on an HTML response throws and becomes "Network error".
    const rawText = await res.text();
    let json;
    try {
      json = JSON.parse(rawText);
    } catch (parseErr) {
      console.error('Non-JSON server response:', rawText);
      showResult(false, 'Server returned an unexpected response. Please try again in a few minutes.');
      resetBtn();
      return;
    }

    const SPECIAL_LABEL   = "{{ special_label }}";
    const SPECIAL_MESSAGE = "{{ special_message }}";

    console.log('Server response:', json);

    if (json.status === 'success') {
      gphRecordSubmit();
      if (label.replace(/[\s-]/g, '') === SPECIAL_LABEL.replace(/[\s-]/g, '')) {
        showResult(true, SPECIAL_MESSAGE);
      } else {
        showResult(true, `Thanks for submitting your label number. Your label is redeemable for ${json.notificationData.prize}. Our team is now reviewing the details and will be reaching out directly with next steps. There is nothing more you need to do right now. Thanks for being part of the drop. Keep an eye on your inbox.`);
      }
      form.reset();
      grecaptcha.reset(recaptchaWidgetId);
      recaptchaVerified = false;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submit Redemption';
    } else {
      showResult(false, json.message || 'Submission failed. Please try again.');
      resetBtn();
    }

  } catch (err) {
    clearTimeout(timeoutId);
    console.error('Submission error:', err);
    if (err.name === 'AbortError') {
      showResult(false, 'The request timed out — the server is taking too long. Please try again.');
    } else {
      showResult(false, 'Network error. Please check your connection and try again.');
    }
    resetBtn();
  }
});
